import { render, staticRenderFns } from "./addAuthorization.vue?vue&type=template&id=b002e1dc&scoped=true"
import script from "./addAuthorization.vue?vue&type=script&lang=js"
export * from "./addAuthorization.vue?vue&type=script&lang=js"
import style0 from "./addAuthorization.vue?vue&type=style&index=0&id=b002e1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b002e1dc",
  null
  
)

export default component.exports